import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "upload" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "icon-jiajianzujianjiahao iconfont"
}

import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
import { uploadImg } from "@/api/backstage";
import type { ElFile } from "element-plus/es/components/upload/src/upload.type";

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  image: String,
  showIcon: Boolean,
},
  emits: ["onSuccess"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

let imageUrl = ref("");

const uploadFile = (filed) => {
  const fileValue = filed.file;
  const formData = new FormData();
  formData.append("file", fileValue, fileValue.name);
  uploadImg(formData).then((res) => {
    if (res.code === 200) {
      imageUrl.value = localStorage.getItem("fileUrel") + res.data.fileName;
      emit("onSuccess", res.data);
    }
  });
};

const beforeAvatarUpload = (file: ElFile) => {
  const isJPG = file.type === "image/jpeg" || file.type === "image/png";
  const isLt2M = file.size / 1024 / 1024 < 10;

  if (!isJPG) {
    ElMessage.error("请上传PNG或者JPG格式的图片");
  }
  if (!isLt2M) {
    ElMessage.error("请上传小于10兆的图片");
  }
  return isJPG && isLt2M;
};

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_upload, {
      class: "avatar-uploader",
      action: "/sys/upload/img",
      "show-file-list": false,
      "before-upload": beforeAvatarUpload,
      "http-request": uploadFile
    }, {
      default: _withCtx(() => [
        (_unref(imageUrl) && !__props.showIcon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(imageUrl),
              class: "avatar"
            }, null, 8, _hoisted_2))
          : (__props.image && !__props.showIcon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: __props.image,
                class: "avatar"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("i", _hoisted_4))
      ]),
      _: 1
    })
  ]))
}
}

})